module.exports = __webpack_public_path__ + "img/filter-left.86f5568f.svg";